{
	"backToManageDeclarations": "Înapoi la gestionarea declarațiilor",
	"kpi": {
		"quantity": "Cantitate",
		"carbonSavings": "Reduceri de CO\u2082"
	},
	"downloadAllDeclarations": "Descarcă toate declarațiile",
	"errors": {
		"notFound": "Proiectul nu a fost găsit"
	}
}
